import { Optional } from '@angular/core';
import { DokItemInfo } from '@app/components/dokumentacija/dokumentacija-types';
import {
  ItemProvider,
  NotificationService,
  ViewWindow,
  WindowRegistry
} from '@ntap/core';
import { PrimeNGButtonOpenItemViewActionComponent } from '@ntap/primeng';
import { map } from 'rxjs';

export abstract class DokumentacijaOpenItemViewActionComponent extends PrimeNGButtonOpenItemViewActionComponent {
  constructor(
    protected override notificationService: NotificationService,
    protected override windowRegistry: WindowRegistry,
    @Optional() protected override window: ViewWindow,
    @Optional() protected override itemProvider: ItemProvider
  ) {
    super(notificationService, windowRegistry, window, itemProvider);
  }

  protected abstract isDisabled(dokInfo: DokItemInfo): boolean;

  protected override initDisabledObservable(): void {
    super.initDisabledObservable();
    this.isDisabled$ = this.itemProvider.item$.pipe(
      map((item) => {
        const dokInfo = new DokItemInfo(item);
        return this.isDisabled(dokInfo);
      })
    );
  }
}
